import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled from 'styled-components';
import { T as Text } from '../../Text/Text-CO4HftGt.js';

const Title = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-40026394__sc-5iwu7-0"
})(["display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;"]);
const DefaultTitle = ({
  label,
  ...rest
}) => /*#__PURE__*/React__default.createElement(Title, _extends({}, rest, {
  size: "medium"
}), label);

export { DefaultTitle as D };
//# sourceMappingURL=DefaultTitle-ChLqQDA9.js.map
